import React, {useCallback, useRef, useState} from "react";
import LKCallScreen from "../screens/LKCallScreen";
import style from "./SideBar.module.css"
import History from "./History";
import {useEffectOnce} from "../hooks/useEffectOnce";
import {useSearchParams} from "react-router-dom";
import ZoomCallScreen from "../screens/ZoomCallScreen";
import VideoCameraFrontIcon from '@mui/icons-material/VideoCameraFront';
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import VideoRecorder from "./VideoRecorder";
import {useTranslation} from "react-i18next";
import Draggable from "react-draggable";

function SideBar(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'sideBar' });
    const [playerName, setPlayerName] = useState(props.loginValid ? "Mentor" : "Player")
    const [onCall, setOnCall] = useState(false)
    const [queryParams] = useSearchParams()
    const [isHorizontal, setHorizontal] = useState(true)
    const lkCallScreenDraggableRef = useRef()

    const [callScreenDetached, setCallScreenDetached] = useState(false)
    const [callScreenX, setCallScreenX] = useState(0)
    const [callScreenY, setCallScreenY] = useState(0)


    const stopTheCallCallback = useCallback(stopTheCall, [onCall])


    function resolveUserName() {
        if (props.loginValid) {
            setPlayerName("Mentor")
        } else {
            setPlayerName("Player")
        }
        startTheCall()
    }

    function startTheCall() {
        setOnCall(true)
        props.setOnVideoCall(true)
    }

    function stopTheCall() {
        setOnCall(false)
        props.setOnVideoCall(false)
    }

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    useEffectOnce(() => {
        if (queryParams.get("autovideo") === "on") {
            startTheCall()
        }
    }, [])

    const detachCallScreenCB = useCallback(() => detachCallScreen(), [callScreenDetached])

    function detachCallScreen() {
        setCallScreenDetached(!callScreenDetached)
        setCallScreenX(0)
        setCallScreenY(0)
    }

    function handleLKCallDrag(event, data) {
        setCallScreenX(data.lastX)
        setCallScreenY(data.lastY)

        if (event.target.className !== "handle" && (Math.abs(data.deltaX) + Math.abs(data.deltaY) < 4)) {
            event.target?.click?.()
        }
    }

    return (
        <>
            <div className={(!onCall) ? style.videoHorizontal : style.video}>
                {
                    !onCall && !props.gameState.is_self_game && (props.gameState.video_allowed !== false) &&
                    <div className={style.flexCentered}>
                        <OverlayTrigger
                            placement="right"
                            delay={{show: 400, hide: 50}}
                            overlay={renderTooltip(t('call'))}
                        >
                            <div className={style.callControl}
                                 onClick={resolveUserName}>
                                <VideoCameraFrontIcon
                                    style={{color: "white", font: "large", scale: "1.5"}}></VideoCameraFrontIcon>
                            </div>
                        </OverlayTrigger>
                    </div>
                }
                {playerName
                    && !props.gameState.is_self_game
                    && (props.gameState.video_allowed !== false)
                    && !props.gameState.is_trial_game
                    && <VideoRecorder controlsHorizontal={(!onCall || callScreenDetached) || props.gameState.video_provider === "zoom"} gameId={props.gameId} name={playerName}></VideoRecorder>}
                {
                    onCall && props.gameState.video_provider === "livekit" &&
                    <Draggable
                        nodeRef={lkCallScreenDraggableRef}
                        axis="both"
                        handle=".callHandle"
                        scale={1}
                        bounds="#boundaries"
                        disabled={!callScreenDetached}
                        defaultPosition={{x: 0, y: 0}}
                        position={{x: callScreenX, y: callScreenY}}
                        onStop={handleLKCallDrag}
                    >
                        <div ref={lkCallScreenDraggableRef}
                             className={`${style.flexLeft} callHandle`}
                             style={{
                                 zIndex:1000,
                                 position: callScreenDetached ? "absolute" : "relative",
                                 cursor: callScreenDetached ? "move" : "default",
                                 borderRadius: "12px",
                                 backdropFilter: "blur(6px)",
                        }}>
                            <LKCallScreen
                                gameId={props.gameId}
                                onStop={stopTheCallCallback}
                                isMentor={props.loginValid}
                                detachCallScreen={detachCallScreenCB}
                                detached={callScreenDetached}
                            />
                        </div>
                    </Draggable>
                }
                {
                    onCall && props.gameState.video_provider === "zoom" &&
                    <ZoomCallScreen gameState={props.gameState} userName={playerName} onStop={stopTheCall}
                                    isHorizontal={isHorizontal} setHorizontal={setHorizontal}/>
                }

            </div>
            <History gameState={props.gameState} updateGameState={props.updateGameState} cards={props.cards}
                     loginValid={props.loginValid}></History>
        </>


    )
}

export default SideBar;